import type { QueryClient } from '@tanstack/react-query';
import type { ProfileTarget } from './profile-api';

/** Both editor APIs read the same CV. A master edit also changes inherited fields. */
export function invalidateCvDocumentQueries(
  queryClient: Pick<QueryClient, 'invalidateQueries'>,
  target?: ProfileTarget,
): Promise<void[]> {
  const normalized = target?.trim();
  const isMaster = !normalized || normalized === 'master';
  const keys = isMaster
    ? [['profile'], ['cv'], ['cvs']]
    : [['profile', normalized], ['cv', normalized], ['cvs']];
  // Each prefix is invalidated once. React Query refetches active observers
  // and marks inactive editors stale, avoiding requests for every saved CV.
  return Promise.all(keys.map((queryKey) => queryClient.invalidateQueries({ queryKey })));
}
